import {DxDataGridComponent} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';

export class DxGridHelper {
  static ConfigureGrid(dataGrid: DxDataGridComponent, gridRequest: GridRequest, gridConfiguration: GridConfiguration) {
    gridConfiguration.dataGrid = dataGrid;
    dataGrid.remoteOperations = gridConfiguration.remoteOperations;
    // dataGrid.dataSource = gridConfiguration.rowsDataSource;
    dataGrid.columns = gridConfiguration.columns;

    dataGrid.paging = gridConfiguration.paging;
    dataGrid.pager = gridConfiguration.pager;
    dataGrid.selection = gridConfiguration.selection;
    dataGrid.filterRow = gridConfiguration.filterRow;
    dataGrid.sorting = gridConfiguration.sorting;
    dataGrid.searchPanel = gridConfiguration.searchPanel;


    dataGrid.dataSource = new DataSource({
      load: function (loadOptions) {

        gridConfiguration.mapGridRequest(gridRequest, loadOptions);

        return gridConfiguration.service.getData(gridRequest)
          .toPromise()
          .then((response: GridResponse) => {

            return {
              data: response.rows,
              totalCount: response.totalCount
            };
          })
          .catch(error => {
            throw new Error(error);
          });
      }
    });
  }
}

export class GridRequest {
  options: any;
}

export class GridResponse {
  rows: GridElementModel[];
  totalCount: number;
}

export class GridConfiguration {

  customSearch: [{
    fieldName: string;
    value: string;
  }];

  service: any;

  remoteOperations = {
    filtering: true,
    sorting: true,
    paging: true,
    grouping: true,
    summary: true
  };

  paging = {
    enabled: true,
    pageIndex: 0,
    pageSize: 10
  };

  pager = {
    showPageSizeSelector: true,
    showNavigationButtons: true,
    allowedPageSizes: [10, 20],
    pageSize: 10,
    showInfo: ''
  };

  selection = {
    mode: 'multiple',
    allowSelectAll: false
  };

  sorting = {
    mode: 'single' // or 'multiple'
  };
  filterRow: any; // { visible: true };

  searchPanel: any; // { visible: true },


  columns: [any];
  dataGrid: DxDataGridComponent;
  rowsDataSource: [any];


  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    if (!gridRequest.options)
      gridRequest.options = {};

    gridRequest.options.filter = loadOptions.filter;
    gridRequest.options.group = loadOptions.group;
    gridRequest.options.requireTotalCount = loadOptions.requireTotalCount;
    gridRequest.options.searchExpr = loadOptions.searchExpr;
    gridRequest.options.searchOperation = loadOptions.searchOperation;
    gridRequest.options.skip = loadOptions.skip;
    gridRequest.options.sort = loadOptions.sort;
    gridRequest.options.take = loadOptions.take;

  }
  refreshGrid() {
    this.dataGrid.instance.getDataSource().reload();
  }
  reloadGrid() {
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearGrouping();
    this.dataGrid.instance.clearSorting();
    this.dataGrid.instance.getDataSource().reload();
  }

}
export class GridElementModel {

  isSelected: boolean;

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/helpers/dx-grid-helper.ts